import script from "./HTMoleGameSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./HTMoleGameSetting.vue?vue&type=script&setup=true&lang=js"

import "./HTMoleGameSetting.vue?vue&type=style&index=0&id=57a9310f&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a9310f"]])

export default __exports__